<template>

  <v-app id="app">
    <router-view id="app-content"></router-view>
  </v-app>

</template>

<script>
export default {
  name: 'App',
  mounted () {
    this.$store.dispatch('getSports')
  }
}
</script>

<style lang="scss">
@import 'styles/main-colors.scss';

@font-face {
  font-family: 'League Spartan';
  src: url(assets/fonts/LeagueSpartan-Bold.otf) format('opentype');
}

@font-face {
  font-family: 'Roboto';
  src: url(assets/fonts/Roboto-Regular.ttf) format('truetype');
}

#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  width: 100%;
  height: 100%;
}

#app-content {
  width: 100%;
  height: 100%;
}

body, html {
  margin: 0;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.shadow {
  box-shadow: 1px 1px 2px 1px mix($background-grey, $background-dark, 70%);
}

</style>



// WEBPACK FOOTER //
// src/App.vue